// The fund's financial year, which starts in the month its "Financial Year
// Start Month" setting names -- April, India's, unless it says otherwise. The
// server sends the month (1 to 12) with the signed-in member's permissions, and
// useAuth() hands it out as financialYearStartMonth. The app draws its year
// filters from the same month, so the two agree.

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** One financial year: its label, and its first and last moment as epoch ms. */
const financialYear = (year, startMonth = 4) => {
  const first = startMonth - 1;
  const last = (first + 11) % 12;
  return {
    year,
    label: `${MONTHS[first]} ${year} - ${MONTHS[last]} ${first === 0 ? year : year + 1}`,
    startdate: new Date(year, first, 1).getTime(),
    // The last second before the next year begins.
    enddate: new Date(year + 1, first, 1).getTime() - 1000,
  };
};

/** The financial year `now` falls in. */
export const currentFinancialYear = (startMonth = 4, now = new Date()) =>
  financialYear(now.getMonth() < startMonth - 1 ? now.getFullYear() - 1 : now.getFullYear(), startMonth);

/** Every financial year from 2019 to the current one, oldest first. */
export const financialYears = (startMonth = 4, from = 2019) => {
  const latest = currentFinancialYear(startMonth).year;
  const years = [];
  for (let year = from; year <= latest; year++) years.push(financialYear(year, startMonth));
  return years;
};
